import widget from './widget';

export default {
  ...widget,
  styles: {
    setsOfCardsModifiers: {
      rail: [
        'R10A',
        'bg-transparent-text-dark-m',
        'bg-transparent-text-dark-t',
        'bg-transparent-text-dark-d',
        'border-custom-d',
      ],
      'in-grid-main': [
        'P20A',
        'bg-transparent-text-dark-m',
        'bg-transparent-text-dark-t',
        'bg-transparent-text-dark-d',
        'border-custom-d',
      ],
    },
    cardModifiers: {
      rail: ['CA30-m', 'CA30-t'],
      'in-grid-main': ['CA30-m', 'CA30-t', 'CA30-d'],
    },
    iconsColor: 'c-dark',
    sectionTitleColor: 'border',
    sectionTitleActiveColor: 'border',
    skeletonColor: 'light',
  },
};
